import { render, staticRenderFns } from "./ObjMap.vue?vue&type=template&id=3142d6c9&"
import script from "./ObjMap.vue?vue&type=script&lang=ts&"
export * from "./ObjMap.vue?vue&type=script&lang=ts&"
import style0 from "./ObjMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports